<form class="mb-5 pb-5" [formGroup]="form" appInvalidControlScroll>
  <div *ngFor="let question of questions; let index = index">
    <app-dynamic-form-question
      [question]="question"
      [questionIndex]="index"
      [form]="form"
      [userId]="userId"
      [org]="org"
      [clientId]="clientId"
      [questionnaireId]="questionnaireId"
      [questionnaireName]="questionnaireName"
      [questionnaireBucket]="questionnaireBucket"
      [s3Credentials]="s3Credentials"
      [uploadBucket]="uploadBucket"
      [lock]="lock"
      [isCustomer]="isCustomer"
      (hideChat)="hideChat($event)"></app-dynamic-form-question>
  </div>

  <div class="d-flex justify-content-end w-70 pe-2 pt-2 z-999 bg-white position-absolute bottom-0" *ngIf="!lock">
    <button mat-button cdkFocusInitial class="text-white bg-secondary px-4 mt-3" (click)="onSubmit('save')" *ngIf="sectionIndex !== sections.length-1">
      <mat-icon *ngIf="loader">
        <mat-spinner [diameter]="20" color="primary"></mat-spinner>
      </mat-icon>
      SAVE & PROCEED
    </button>
    <button mat-button cdkFocusInitial class="text-white bg-secondary px-4 mt-3" (click)="onSubmit('submit')" *ngIf="sectionIndex === sections.length-1">
      <mat-icon *ngIf="loader">
        <mat-spinner [diameter]="20" color="primary"></mat-spinner>
      </mat-icon>
      SUBMIT
    </button>
  </div>
</form>
